<mat-form-field class="modern-input" [appearance]="appearance" [class.generic-control-invalid]="ngControl && ngControl.invalid && ngControl.touched">
  <mat-label>{{ label | localize }}</mat-label>

  <mat-icon *ngIf="prefixIcon" matPrefix>{{ prefixIcon }}</mat-icon>
  <span *ngIf="prefixText" matPrefix>{{ prefixText }}&nbsp;</span>

  <textarea
    *ngIf="variant === 'textarea'"
    #nativeTextarea
    matInput
    [rows]="rows"
    [placeholder]="placeholder | localize"
    [required]="required"
    [readonly]="readonly"
    [disabled]="disabled"
    [attr.maxlength]="maxlength"
    (input)="onInputChange($event.target.value)"
    (blur)="onTouched()"
  ></textarea>

  <!-- Con máscara: el <input> se maneja con un FormControl real propio (maskedControl)
       en el mismo elemento que [mask], para que ngx-mask preserve el cursor bien. -->
  <input
    *ngIf="variant !== 'textarea' && mask"
    matInput
    [type]="type"
    [formControl]="maskedControl"
    [placeholder]="placeholder | localize"
    [required]="required"
    [readonly]="readonly"
    [mask]="mask"
    [specialCharacters]="specialCharacters"
    [attr.maxlength]="maxlength"
    (blur)="onTouched()"
    (keyup.enter)="onEnter()"
  >

  <input
    *ngIf="variant !== 'textarea' && !mask"
    #nativeInput
    matInput
    [type]="effectiveType"
    [placeholder]="placeholder | localize"
    [required]="required"
    [readonly]="readonly"
    [disabled]="disabled"
    [attr.maxlength]="maxlength"
    (input)="onInputChange($event.target.value)"
    (blur)="onTouched()"
    (keyup.enter)="onEnter()"
  >

  <mat-icon *ngIf="suffixIcon" matSuffix (click)="onSuffixIconClick()">{{ suffixIcon }}</mat-icon>
  <span *ngIf="suffixText" matSuffix>{{ suffixText }}</span>
  <button
    *ngIf="type === 'password'"
    type="button"
    mat-icon-button
    matSuffix
    tabindex="-1"
    (click)="togglePasswordVisibility()"
  >
    <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>

  <mat-hint *ngIf="showError && ngControl && ngControl.invalid && ngControl.touched" class="generic-control-error-hint">
    {{ getErrorMessages() }}
  </mat-hint>
  <mat-hint *ngIf="hint && !(showError && ngControl && ngControl.invalid && ngControl.touched)">{{ hint | localize }}</mat-hint>
</mat-form-field>
